<template lang="pug">
  div.lmm-content-body-padded
    b-container(fluid)
      b-row
        b-col.page-wrap(cols="12")
          div(slot="header").d-flex.justify-content-between.page-header
            b-container.d-flex.justify-content-between(fluid)
              div
                span.page-title {{$t('user')}} {{$t('login')}} {{$t('history')}}
          b-container(fluid)
            b-row
              b-card.w-100(no-body)
                b-container(slot="header", fluid)
                  b-row
                    b-col(cols="2")
                      datepicker(
                        :value="range.start",
                        :bootstrap-styling="true",
                        format="yyyy-MM-dd",
                        :language="range.lang",
                        @selected="startDateChanged")
                    b-col(cols="2")
                      datepicker(
                        :value="range.end",
                        :bootstrap-styling="true",
                        format="yyyy-MM-dd",
                        :language="range.lang",
                        :disabledDates="range.disabledDates",
                        @selected="endDateChanged")
                    b-col(cols="2")
                      b-form-select(v-model="filter.key", :options="filter.options", size="sm", @change="keyChangeHandler")
                    b-col(cols="2")
                      template(v-if="filter.key === 'os'")
                        b-form-select(v-model="filter.value", :options="filter.osOptions", size="sm")
                      template(v-else)
                        b-form-input(v-model="filter.value", size="sm", @keydown.enter="tableRefresh")
                    b-col(cols="2")
                      b-button(size="sm", @click="tableRefresh") {{$t('search')}}
                    b-col.ml-auto.text-right(cols="2")
                      b-button(size="sm", variant="info", :disabled="!excelLoaded", @click="downloadExcel") EXCEL
                b-table(
                  ref="dataTable",
                  :fields="fields",
                  :items="items",
                  :current-page="page.current",
                  :per-page="page.per",
                  :show-empty="true",
                  tbody-class="lmm-table-body",
                  :empty-text="$t('no-content')")
                  template(slot="table-colgroup")
                    col(style="width: 20%; max-width: 25%")
                  template(slot="HEAD_mgrid", slot-scope="data")
                    | {{$t('ID')}}
                  template(slot="HEAD_mgr_ip", slot-scope="data")
                    | {{$t('user')}} IP
                  template(slot="HEAD_login_time", slot-scope="data")
                    | {{$t('login_time')}}
                  template(slot="HEAD_browser", slot-scope="data")
                    | {{$t('browser')}}/{{$t('CS_manager')}}
                  template(v-slot:cell(login_time)="row")
                    | {{row.item.login_time | moment('add', AppState.Info.timezoneOffset, 'YY/MM/DD HH:mm')}}
                  template(v-slot:cell(mgr_ip)="row")
                    span {{row.item.mgr_pub_ip}}
                    span ({{row.item.mgr_pri_ip}})
                  template(v-slot:cell(login_from)="row")
                    icon(:name="getOS(row.item.login_from)")
                  template(v-slot:cell(browser)="row")
                    | {{row.item.browser || 'CS'}}
                div.d-flex.justify-content-between(slot="footer")
                  div
                    b-form-select(
                      size="sm",
                      v-model="page.per",
                      :options="page.perOptions")
                  b-pagination(
                    size="sm",
                    :total-rows="page.total",
                    :per-page="page.per",
                    v-model="page.current",
                    class="my-0 float-right"
                  )
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import {getCurrentLanguage} from '@/i18n'
import * as datePickerLocale from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'
import {AnalysticAPI} from '../../api'

export default {
  name: 'log-access-component',
  components: { Datepicker },
  methods: {
    downloadExcel () {
      if (this.excelLoaded && this.excelLink) {
        location.href = this.excelLink
      }
    },
    keyChangeHandler () {
      this.filter.value = ''
    },
    startDateChanged (date) {
      this.range.start = date
      this.range.disabledDates.to = date
    },
    endDateChanged (date) {
      this.range.end = date
    },
    tableRefresh () {
      this.page.current = 1
      this.$refs.dataTable.refresh()
    },
    getOS (id) {
      switch (id) {
        case 1: return 'windows'
        default: return 'windows'
      }
    },
    items (ctx) {
      let params = {
        by: 'create_time',
        start_date: moment(this.range.start).format('YYYY-MM-DD'),
        end_date: moment(this.range.end).format('YYYY-MM-DD'),
        limit: ctx.perPage,
        offset: ctx.perPage * (ctx.currentPage - 1),
        order: 'desc',
        export_id: 'accessHistoryTable'
      }
      if (this.filter.value) {
        params.search_key = this.filter.key
        params.search_value = this.filter.value
      }
      AnalysticAPI.excel.post('', params)
        .then((resp) => {
          if (!resp.data.objects.length) {
            const downloadUrl = resp.data.objects.download_url
            const fileName = resp.data.objects.file_name
            if (process.env.VUE_APP_SCI) {
              this.excelLink = `${this.AppState.Path.origin}:8443${downloadUrl}/${fileName}`
            } else {
              this.excelLink = `${this.AppState.Path.origin}${downloadUrl}/${fileName}`
            }
            this.excelLoaded = true
          } else {
            this.excelLink = null
            this.excelLoaded = false
          }
        })
      return AnalysticAPI.history.get('access', {params})
        .then(resp => {
          this.page.total = resp.data.meta.total_count
          return _.filter(resp.data.objects, v => v.pk !== 'EMPTY')
        })
    }
  },
  data () {
    let disabledDateInit = new Date()
    disabledDateInit.setDate(-1)
    return {
      excelLoaded: false,
      excelLink: null,
      range: {
        start: (new Date().setDate(-1)),
        end: new Date(),
        disabledDates: { to: disabledDateInit },
        lang: datePickerLocale[getCurrentLanguage()]
      },
      fields: [
        { key: 'mgrid', label: 'ID' },
        { key: 'mgr_ip', label: this.$t('ip-address') },
        { key: 'browser', label: this.$t('browser') },
        { key: 'login_time', label: this.$t('access_time') }
      ],
      page: {
        total: 0,
        current: 1,
        per: 10,
        perOptions: [
          { value: 5, text: '5' },
          { value: 10, text: '10' },
          { value: 15, text: '15' },
          { value: 20, text: '20' }
        ]
      },
      filter: {
        key: 'e-mail',
        value: '',
        options: [
          { text: this.$t('ID'), value: 'e-mail' },
          { text: this.$t('browser'), value: 'browser' }
        ],
        osOptions: [
          { text: this.$t('please_select'), value: '' },
          { text: this.$t('windows'), value: 1 },
          { text: this.$t('linux'), value: 2 },
          { text: this.$t('mac'), value: 3 },
          { text: this.$t('android'), value: 4 },
          { text: this.$t('ios'), value: 5 }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.lmm-content-body-padded {
  padding: 0;
  margin: 0;
}

.row, .col, .container-fluid, .container {
  margin: 0;
  padding: 0;
}

.page-wrap {
  padding: 1rem 1.5rem;
}

.page-header {
  padding: 0 1.5rem 0 1.5rem;
  margin-bottom: 0.5rem;
}

.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
}


::v-deep .b-table {
  margin: 0;
  table-layout: fixed;
  width: 100%;
  tr, td, th {
    padding: 0.5rem 0 0.5rem 1rem;
    position: relative;
    font-weight: 400;
  }
  th:nth-child(1), th:nth-child(2), th:nth-child(3), th:nth-child(4) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
  }
  th:nth-child(1), td:nth-child(1) {
    padding-left: 1rem;
  }
  td:nth-child(1), td:nth-child(2), td:nth-child(3), td:nth-child(4) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
    color: #6F6F6F;
  }
}

::v-deep .form-control, .custom-select {
  display: flex;
  background-color: #FFFFFF !important;
  border: 1px solid #6F6F6F !important;
  border-radius: 0;
  height: 1.75rem;
  align-items: center;
  text-align: left !important;
}
</style>
